module.exports = __webpack_public_path__ + "img/puzzle_20.7104f5fa.png";